export const API_ERROR = "API_ERROR";
export const SHOW_SIDEBAR = "SHOW_SIDEBAR";
export const SET_ACTIVE_TAB = "SET_ACTIVE_TAB";
export const SET_ACTIVE_FOOTER_TAB = "SET_ACTIVE_FOOTER_TAB";
export const SET_HIDE_GLOBAL_HEADER_MOBILE = "SET_HIDE_GLOBAL_HEADER_MOBILE";
